@if ($hasSidebar()) {
    <meta-sidebar [menuItems]="sidebarMenuItems" [userMenuItems]="sidebarUserMenuItems"
        [activeItem]="activeItem$ | async" [hideUserMenu]="config.hideUserMenu || false"
        (statusChanged)="$sideBarShown.set($event)" (menuItemClicked)="handleMenuItemClicked($event.id)"
        (userMenuItemClicked)="handleUserMenuItemClicked($event.id)" />
}

<main id="mainContent" class="flex flex-col flex-1 transition-all duration-300 pb-6"
    [ngClass]="{
        'xl:pl-sidebar': $hasSidebar() && $sideBarShown(),
        'bg-body': !$showOnlyContent()
    }">
    @if (!$hasSidebar() && !$showOnlyContent()) {
        <header class="pt-6 pb-5 w-full flex justify-center bg-primary mb-10">
            <img class="max-h-[3.75rem] mx-auto" [src]="mainLogo" [alt]="name" role="presentation">
        </header>
    }
    <section class="pt-6 pb-3 px-base xl:px-base-desk mb-6">
        <div [ngClass]="{
            'max-w-[55.375rem] mx-auto': !$hasSidebar() && !$showOnlyContent(),
            'bg-body': !$showOnlyContent()
            }">
            @if (!$showOnlyContent()) {
                <h1 class="text-4xl font-bold mb-4">{{codeOfConductTitle | translate}}</h1>
            }
            <!-- TODO: Inserire testo Code of Conduct -->
            @for (section of $codeOfConductSections(); track $index) {
                @if (section.title) {
                    <h2 class="font-semibold text-xl mt-2">{{section.title}}</h2>
                }
                @if (section.type === 'text') {
                    <div class="mb-2" [innerHTML]="section.text"></div>
                }
                @if (section.type === 'list') {
                    @if (section.description) {
                        <div class="mb-2" [innerHTML]="section.description"></div>
                    }
                    <ul class="pl-6 mb-2" [ngClass]="{
                            'list-disc': section.symbol === 'dot',
                            'list-decimal': section.symbol === 'index',
                            'list-none': section.symbol === 'none' || !section.symbol
                        }">
                        @for (listItem of section.list; track $index) {
                            <li class="font-semibold">
                                @if (listItem.title) {
                                    <div>{{ listItem.title }}</div>
                                }
                                <div class="font-normal" [innerHTML]="listItem.text"></div>
                            </li>
                        }
                    </ul>
                }
            }
        </div>
    </section>

    @if (!$showOnlyContent()) {
        <meta-footer [hideCustomFooter]="$hideFooter()" />
    }
</main>
